import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 1, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ children, delay = 0, className = "" }) => (
  <span className={`line-mask ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%", rotate: 2 }}
      animate={{ y: 0, rotate: 0 }}
      transition={{ duration: 1.1, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);
